import { roles } from '@/config/roles'

const routes = [
  {
    name: 'EducationList',
    path: '/education',
    meta: { label: '' },
    component: () => import('@/views/education/index.vue')
  },
  {
    name: 'CourseBookPage',
    path: '/education/:courseBookId',
    meta: { label: '' },
    redirect: '/',
    component: () => import('@/views/education/course/index.vue'),
    children: [
      {
        name: 'CourseBookContent',
        path: '/',
        meta: { label: '' },
        component: () => import('@/views/education/course/Content.vue')
      },
      {
        name: 'CourseBookEmptySection',
        path: 'test/:sectionId/',
        meta: { label: '' },
        component: () => import('@/views/education/course/EmptySection.vue')
      },
      {
        name: 'CourseBookSubSection',
        path: 'section/:sectionId/subsection/:subsectionId',
        meta: { label: '' },
        component: () => import('@/views/education/course/SubSection.vue')
      },
      {
        name: 'CourseBookProgress',
        path: 'students-progress',
        meta: {
          label: '',
          roles: [roles.teacher, roles.curator]
        },
        component: () => import('@/views/education/course/Progress.vue')
      },
      {
        name: 'CourseBookTestReport',
        path: 'test/:sectionId/test-report',
        meta: {
          label: '',
          roles: [roles.teacher, roles.curator]
        },
        component: () => import('@/views/education/course/TestReport.vue')
      }
    ]
  },
  {
    name: 'TrainingPage',
    path: '/education/training/:trainingId',
    meta: { label: '' },
    redirect: '/',
    component: () => import('@/views/education/training/index.vue'),
    children: [
      {
        name: 'TrainingContentPage',
        path: '/',
        meta: { label: '' },
        component: () => import('@/views/education/training/Content.vue')
      },
      {
        name: 'GroupTrainingPage',
        path: 'group-settings',
        meta: { label: '' },
        component: () => import('@/views/education/training/Group.vue')
      },
      {
        name: 'TrainingReportPage',
        path: 'progress',
        meta: { label: '' },
        component: () => import('@/views/education/training/Report.vue')
      },
      {
        name: 'TrainingStepPage',
        path: 'stages/:stageIndex',
        meta: { label: '' },
        component: () => import('@/views/education/training/Step.vue')
      },
      {
        name: 'GroupTrainingStepPage',
        path: 'stages/group',
        meta: { label: '' },
        component: () => import('@/views/education/training/GroupStep.vue')
      }
    ]
  }
]

export default routes
